import { Modal } from "@mantine/core";
import React from "react";

import ModalHeader from "components/ModalHeader";

import AddOrgMembersForm from "./AddOrgMermbersForm";
import { Organization } from "types";
import AddProgramForm from "./AddOrgMermbersForm";

type CreateProjectModalProps = {
  opened: boolean;
  onClose: () => void;
  org?: Organization;
};

function ProgramAddModal({ opened, onClose, org }: CreateProjectModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      overlayOpacity={0.5}
      shadow="xs"
      withCloseButton={false}
      transitionDuration={300}
      centered
    >
      <ModalHeader
        title="Add Program"
        onClose={onClose}
        ariaLabel="Close add program modal"
      />
      <AddProgramForm onClose={onClose} />
    </Modal>
  );
}

export default ProgramAddModal;
